/**
 * Format a number as USD currency with comma separators.
 * e.g. 1234.5 → "1,234.50"
 *
 * Does NOT include the "$" prefix — callers add that in JSX.
 */
export function fmtMoney(value) {
  const num = Number(value) || 0;
  return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/**
 * Format a unit price preserving its actual decimal places (minimum 2).
 * e.g. 0.725 → "0.725", 150 → "150.00", 1.5 → "1.50"
 */
export function fmtPrice(value) {
  const num = Number(value) || 0;
  const str = String(value);
  let decimals = 2;
  if (str.includes('.')) {
    const parts = str.split('.');
    decimals = Math.max(parts[1].replace(/0+$/, '').length, 2);
  }
  return num.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}
